/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect, useContext, useState, useMemo } from 'react';
import _ from 'lodash';
import appConfig from 'app-config';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import {
    MLConfirmationPolicyDetailsBox
} from 'ml-capability-policychange-common-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { LocalDateUtil } from '@xengage/gw-portals-util-js';
import { MLTagManagerService, MLModalService } from 'ml-portals-services-react'
import { UserService } from 'gw-capability-gateway';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MLQuoteNameUtil } from 'ml-portals-util-js';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { PolicyService } from 'gw-capability-policy';
import { DocumentDownloadService } from '@xengage/gw-portals-document-js';
import PolChangeTrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PolChangeTrackEvent.jsx';
import { MLNewDocumentsCounterService, MLNavigationStepsTrackingService } from 'ml-services-common-react';
import ampMetadata from './CEConfirmationPolChange.metadata.json5';
import { Identify  } from '../../../gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/TrackEvent';

import metadata from './ConfirmationPolChange.metadata.json5';
import messages from './ConfirmationPolChange.messages';
import styles from './ConfirmationPolChange.module.scss';
import { Button } from '@jutro/legacy/components';
import { TooltipIcon  } from '@jutro/components';

import { IntlContext } from '@jutro/legacy/locale';

const {
    MLUserTypes
} = appConfig;

function ConfirmationPolChange(props) {
    const { wizardData, history, currentStep } = props;
    const { submissionVM } = wizardData;
    const translator = useTranslator();
    const { EndorsementService } = useDependencies('EndorsementService');
    const AlertService = MLNotificationBlockUtil();
    const intl = useContext(IntlContext);
    const isGPA = appConfig.portalCode === 'GPA';
    const isAMP = appConfig.portalCode === 'AMP';
    const isGateway = appConfig.persona === 'producer' || appConfig.persona === 'csr';
    const changesAppliedForwardText = isGateway ? messages.contactUnderwriterMessage : messages.contactAgentMessage;
    const { authHeader } = useAuthentication();
    const { showErrorModal, showProgressDialog} = MLModalService();
    
    const isAgentMode = submissionVM.isSubmitAgent.value;
    const hasFutureRenewals = _.get(submissionVM, 'value.hasFutureRenewals_ML', false);
    const changesAppliedForward = _.get(submissionVM, 'value.changesAppliedForward', false);
    const requiredDocumentation_ML = _.get(submissionVM, 'requiredDocumentation_ML.value', []);
    const policyNumber = _.get(submissionVM, 'policyNumber.value', null);

    const [policyDetails, setPolicyDetails] = useState(undefined);
    const paymentSchedule = useMemo(() => {
        const selectedPaymentPlan = _.get(submissionVM, 'value.paymentDetails_ML.paymentPlans_ML', []).find((plan) => {
            return plan?.billingId === _.get(submissionVM, 'value.paymentDetails_ML.selectedPaymentPlan');
        });
        return selectedPaymentPlan ? selectedPaymentPlan.name : '';
    }, [submissionVM])
    
    const isIAorPCSorMetGAAgent = (user) => {
        return !_.isNil(user)
            && (user.userType === MLUserTypes.IA
            || user.userType === MLUserTypes.PCS
            || user.userType === MLUserTypes.MET_GA);
    };

    const getFutureRenewalAndAppliedForwardMessage = (() => {
        // changesAppliedForward is the flag to determine policy change has been applied to the future unbound peroid properly.
        if (isAgentMode && !hasFutureRenewals && changesAppliedForward) {
            if (MLUserTypes.IA || MLUserTypes.PCS || MLUserTypes.MET_GA) {
                const message1 = translator(messages.iAorPCSFutureRenewalMessage);
                AlertService.addErrorAlert(message1, 'Action Needed', false, 'futureRenewalAndAppliedForwardMessage');
            } else {
                const message2 = translator(messages.nonIAorPCSFutureRenewalMessage);          
                AlertService.addErrorAlert(message2, 'Action Needed', false, 'futureRenewalAndAppliedForwardMessage');
            }
        } else {
            AlertService.clearAlerts();
        }
    });

    const isPersonalAuto = () => {
        return submissionVM.value.isPersonalAuto();
    };

    const isHomeOwners = () => {
        return submissionVM.value.isHomeOwners();
    };

    const viewLatestIDCard = () => {
        const cardPromise = PolicyService.getLatestIDCard(policyNumber, authHeader);
        
        cardPromise.then((idCard) => {
            const publicID = idCard.publicID;
            const sessionID = idCard.sessionID;
            const xCenter = idCard.xCenter || idCard.xCenter_ML;

            let xCenterRetrievalURI;
            switch (xCenter) {
                case 'cc':
                    xCenterRetrievalURI = getProxiedServiceUrl('claimDocument');
                    break;
                case 'bc':
                    xCenterRetrievalURI = getProxiedServiceUrl('billingDocument');
                    break;
                case 'pc':
                default:
                    xCenterRetrievalURI = getProxiedServiceUrl('policyDocument');
            };
            const displayErrorModal = () => showErrorModal(messages.documentDownloadErrorHeader, messages.documentDownloadErrorMessage);
            const documentServiceURL = DocumentDownloadService.getDocumentLink(xCenterRetrievalURI, publicID, sessionID);
            const documentServicePromise = DocumentDownloadService.getDocument(documentServiceURL, authHeader, displayErrorModal);
            showProgressDialog(messages.downloadingDocument, documentServicePromise);

            documentServicePromise.then(() => {
                if (idCard.newToPortal || idCard.newToPortal_ML) {
                    MLNewDocumentsCounterService.setDocumentAsViewed(xCenter, publicID, sessionID, idCard, authHeader);
                }
            })
            MLTagManagerService.sendLinkClickEvent('Confirmation_View and print');
        });
    };


    const viewPolicyDocuments = () => {
        MLTagManagerService.sendLinkClickEvent('Confirmation_View_Your Policy Documents');
        if (isAMP) {
            history.push('/documents');
        }
        else {
            history.push(`/policies/${submissionVM.value.policyNumber}/documents`);
        }
    };

    const viewIDCards = () => {
        MLTagManagerService.sendLinkClickEvent('Confirmation_View_Your ID Cards');
        history.push(`/accounts/${submissionVM.value.baseData.accountNumber}/documents`);
    };

    const printConfirmation = () => {
        MLTagManagerService.sendLinkClickEvent('Confirmation_Print Confirmation');
        window.print();
    };

    const goToAccount = () => {
        if (isAMP) {
            MLTagManagerService.sendLinkClickEvent('Confirmation_Review your account');
            history.push('/home');
        } else {
            history.push(`/accounts/${submissionVM.value.baseData.accountNumber}/summary`);
        }
    };

    const anyOpenOrClosedContingencies = () => {
        return _.get(policyDetails, 'openOrClosedContingencies') ? policyDetails.openOrClosedContingencies.length > 0 : false;
    };

    const actionCell = (obj, index) => {
        if(index === 0) {
            return <div>
                <a onClick={viewPolicyDocuments}>{translator(messages.view)}</a>
                <a>{translator(messages.send)}</a>
            </div>
        }
        return <div>
            <a onClick={viewIDCards}>{translator(messages.view)}</a>
            <a>{translator(messages.send)}</a>
        </div>
    }

    const documentCell = (obj, index) => {
        if(index === 0) {
            return <>{translator(messages.yourPolicyDocuments)}</>
        }
        return <>{translator(messages.yourIDCards)}</>
    }

    const hasRequiredDocumentation = () => {
        return requiredDocumentation_ML && requiredDocumentation_ML.length > 0;
    };

    const _callIsPeriodBound = (request, callback) => {
        return EndorsementService.isJobBound(request, authHeader).then((isBound) => {
            callback(isBound === true);
        }).catch(() => {
            callback(false);
        });
    };

    const _retryIsPeriodBoundUntilLimit = (request, counter, callback) => {
        const maxRetry = 15;
        if (counter > maxRetry) {
            callback(undefined);
        } else {
            _callIsPeriodBound(request, (periodsBound) => {
                if (periodsBound) {
                    return EndorsementService.getPolicyChangeDetails(request, authHeader)
                        .then((polDetails) => {
                            callback(polDetails);
                        }).catch(() => {
                            callback(undefined);
                        });
                }
                counter++;
                setTimeout(() => {
                    _retryIsPeriodBoundUntilLimit(request, counter, callback);
                }, 1000);
            });
        }
    };

    const _populatePolicySummariesWhenBound = () => {
        const promise = new Promise((resolve) => {
            const request = submissionVM.jobID.value;
            _retryIsPeriodBoundUntilLimit(request, 0, (results) => {
                resolve();
                if (results) {
                    setPolicyDetails(results)
                }
                // else do nothing to still show confirmation page with limited post bound data.
            });

        })
        showProgressDialog(messages.loading, promise);
    }

    const retrieveEndorsement = () => {
        const policyDetailsPromise = EndorsementService.getPolicyChangeDetails(submissionVM.jobID.value, authHeader).then((polDetails) => {
            setPolicyDetails(polDetails);
            setTimeout(_populatePolicySummariesWhenBound, 100);
        });
        showProgressDialog(messages.loading, policyDetailsPromise);
    }

    useEffect(() => {
        Identify('Endorsement Step Reached', {step: 'Confirmation Screen'}, submissionVM, authHeader)
    }, [])
    
    useEffect(() => {
        MLNavigationStepsTrackingService.stepChange(null, currentStep.mlStepName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Initial Load
    useEffect(() => {
        if (isAgentMode) {
            retrieveEndorsement();
            const userPromise = UserService.getCurrentUser(authHeader);
            userPromise.then((user) => {
                isIAorPCSorMetGAAgent(user);
            });
            getFutureRenewalAndAppliedForwardMessage();
        }else{
            retrieveEndorsement();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
 useEffect(() => {
     if (isGPA) {
         PolChangeTrackEvent('Endorsement Step Reached', false, submissionVM, authHeader, { step: 'PolChange Confirmation Screen' });
     }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const formatDate = (gwDateVal) => {
        if(gwDateVal){
            const date = LocalDateUtil.toMidnightDate(gwDateVal);
            return intl.formatDate(date, { year: 'numeric', month: '2-digit', day: '2-digit' })
        }
    };

    const goToPolicy = useCallback(() => {
        const redirectPath = isGateway ? `/policies/${policyNumber}/summary` : '/';
        history.push(redirectPath);
    }, [history, isGateway, submissionVM.value]);

    const checkProductCodeDisplayMessage = () => {
        return isHomeOwners() ? translator(messages.typePolicy, {
            policyType: MLQuoteNameUtil.getCoveragePartTypeName(_.get(submissionVM, 'lobData.value.homeowners.coverables.coveragePartType_ML'))}) : translator(messages.typePolicy, {
            policyType: MLQuoteNameUtil.getProductName(_.get(submissionVM, 'value.baseData.productCode'))})
    };

    const getAMPDocumentTableContent = () => {
        return (
            <>
                <h3 className="section-header vertical-spacing-20">{checkProductCodeDisplayMessage()}</h3>

                <table className={styles.documentTable}>
                    <tbody>

                        <tr>
                            <td>
                                <p className="body-copy font-weight-bold">{translator(messages.yourPolicyDocuments)}</p>
                                <p className="body-copy">{translator(messages.variousSupplementaryDocuments)}</p>
                            </td>
                            <td className="text-align-right">
                                <Button type="outlined" onClick={viewPolicyDocuments}>
                                    {translator(messages.viewButton)}
                                </Button>
                            </td>
                        </tr>

                        { isPersonalAuto() &&  
                            <tr>
                                <td>
                                    <p className="body-copy font-weight-bold">{translator(messages.yourIDCards)}</p>
                                    <p className="body-copy">{translator(messages.viewAndPrintYourIDCards)}</p>
                                </td>
                                <td className="text-align-right">
                                    <Button type="outlined" onClick={viewLatestIDCard}>
                                        {translator(messages.viewAndPrintButton)}
                                    </Button>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>

            </>
        );
    }
    const ampOverrides = {
        polChangeEffectiveMessage: {
            content: (
                <FormattedMessage
                    {...messages.effectiveDateMsg}
                    values={{
                        effectiveDate: translator(messages.effectiveDate),
                        date: <strong>{ intl.formatDate(LocalDateUtil.toMidnightDate(submissionVM.baseData.effectiveDate.value), { year: 'numeric', month: 'short', day: 'numeric' }) }</strong>
                    }}
                />
            )
        },
        documentTableContainer: {
            content: getAMPDocumentTableContent()
        },
        pageHeaderTitle: {
            className: styles.confirmationLabel
        },
        hoAccountHasUmbrellaPoliciesMessage : {
            visible: isHomeOwners() && submissionVM.baseData.accountHasUmbrellaPolicies_ML.value
        },
        paAccountHasUmbrellaPoliciesMessage : {
            visible: isPersonalAuto() && submissionVM.baseData.accountHasUmbrellaPolicies_ML.value
        },
        hasRequiredDocs : {
            visible: hasRequiredDocumentation()
        },
        documentIterable: {
            content: hasRequiredDocumentation() ? (<div>
                {requiredDocumentation_ML.map((value) => {
                    return <div>
                        <li>{value}</li>
                    </div>
                })}
            </div>) : undefined 
        }, 
        anyOpenOrClosedContingencies : {
            visible: anyOpenOrClosedContingencies()
        },
        contingenciesIterable: {
            content: anyOpenOrClosedContingencies() ? (<div>
                {policyDetails.openOrClosedContingencies?.map((value) => {
                    return <div>
                        <li>{value.title}</li>
                    </div>
                })}
            </div>) : undefined 
        }
    };

    const override = {
        documentTableHeader: {
            content: checkProductCodeDisplayMessage()
        },
        documentTable: {
            data: isPersonalAuto() ? [{},{}] : [{}] 
        },
        pageHeaderTitle: {
            className: styles.confirmationLabel
        },
        policyChangeConfirmationMessage: {
            className: styles.inlineNotificationStyle,
            content: changesAppliedForward && changesAppliedForwardText
        },
        policyDetails: {
            changeTypeLabel: translator(messages.change),
            policyNumber: _.get(submissionVM, 'value.policyNumber'),
            paymentMethod: _.get(submissionVM, 'value.paymentDetails_ML.ratingPaymentMethod_ML'),
            endingIn: _.get(submissionVM, 'value.paymentDetails_ML.last4Digits_ML'),
            paymentSchedule:  paymentSchedule,
            insured: _.get(submissionVM, 'value.baseData.policyContact_ML', {}),
            policyAddress: _.get(submissionVM, 'value.baseData.policyAddress', {}),
            secondaryInsured: _.get(submissionVM, 'value.baseData.secondaryNamedInsured_ML', undefined),
            effectiveDate: formatDate(_.get(submissionVM, 'value.baseData.effectiveDate')),
            expirationDate: formatDate(_.get(submissionVM, 'value.baseData.periodEndDate')),
            amount: _.get(submissionVM, 'transactionCost.value')

        },
        hoAccountHasUmbrellaPoliciesMessage : {
            visible: isHomeOwners() && submissionVM.baseData.accountHasUmbrellaPolicies_ML.value
        },
        paAccountHasUmbrellaPoliciesMessage : {
            visible: isPersonalAuto() && submissionVM.baseData.accountHasUmbrellaPolicies_ML.value
        },
        anyOpenOrClosedContingencies : {
            visible: anyOpenOrClosedContingencies()
        },
        documentIterable: {
            content: anyOpenOrClosedContingencies() ? (<div>
                {policyDetails.openOrClosedContingencies?.map((value) => {
                    return <div>
                            <li>{value.title} 
                                <TooltipIcon
                                    text={value.description_ML}
                                />
                            </li>
                    </div>
                })}
            </div>) : undefined 
        }
    }
    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            goToPolicy: goToPolicy,
            printConfirmation,
            goToAccount,
            documentCell,
            actionCell
        },
        resolveComponentMap: {
            MLConfirmationPolicyDetailsBox
        }
    };

    return (
        <WizardPage
            showCancel={false}
            showPrevious={false}
            showNext={false}
            policyChangePageHeaderML={messages.policychangeconfirmation}
        >
            <ViewModelForm
                uiProps={isAMP ? ampMetadata.pageContent: metadata.pageContent}
                model={submissionVM}
                overrideProps={isAMP ? ampOverrides : override}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
            />
        </WizardPage>
    );
}

ConfirmationPolChange.propTypes = wizardProps;
export default withRouter(ConfirmationPolChange);